import { RowsDescriptorType } from './rows-descriptor-type';

export abstract class RowsDescriptor {
  constructor(readonly type: RowsDescriptorType) {}
}
